import { Theme as CarlecTheme } from "@pg-flex/shared-js/theme";
import { FC, ReactNode } from "react";

import { variables } from "./variables";

type Props = {
  children: ReactNode;
};

export const Theme: FC<Props> = ({ children }) => {
  return <CarlecTheme variables={variables}>{children}</CarlecTheme>;
};
